import {
  Flex,
} from 'web-styled';

import {
  WorkoutEvent,
  Exercise,
  Namespace,
} from '@gymcloud/core';

import EventHeader from './EventHeader';
import EventNavigation from './EventNavigation';
import Exercises from './Exercises';

type Props = {
  event: WorkoutEvent,
  exercises: Exercise[],
  namespace: Namespace,
  onFinished: { (): void },
  onRemoveAll: { (): void },
};

const EventResults = ({
  event,
  exercises,
  namespace,
  onFinished,
  onRemoveAll,
}: Props) => (
  <Flex
    column
    noScroll
    fillSpace
    align="center"
    justify="flex-start"
  >
    <EventHeader
      event={event}
      namespace={namespace}
    />
    <EventNavigation
      event={event}
      onFinished={onFinished}
    />
    <Exercises
      event={event}
      exercises={exercises}
      onFinished={onFinished}
      onRemoveAll={onRemoveAll}
    />
  </Flex>
);

export default EventResults;
